import { type ReactElement } from "react";
import { styled, Tooltip, tooltipClasses, type TooltipProps } from "~/common/mui";
import { C_INVERSE_ON_SURFACE, C_INVERSE_SURFACE } from "~/common/components/icon/Colors";

interface TooltipWithArrowProps extends TooltipProps {
  children: ReactElement;
  hideTooltip?: boolean;
}

export const TooltipWithArrow = (props: TooltipWithArrowProps) => {
  const { children, hideTooltip = false, ...rest } = props;

  return !hideTooltip ? <StyledTooltip {...rest}>{children}</StyledTooltip> : <>{children}</>;
};

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: C_INVERSE_SURFACE,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: C_INVERSE_SURFACE,
    color: C_INVERSE_ON_SURFACE,
  },
}));
